<template>
  <div
    v-if="isLoaded"
    class="shared-app"
  >
    <shared-gantt-view
      v-if="viewType === 'gantt'"
      :project-id="projectId"
      :multiview-id="multiviewId"
    />

    <shared-board-page
      v-if="viewType === 'board'"
    />

    <app-filter />
    <portal-target name="task-resources-preview" />
    <portal-target name="task-custom-column-preview" />
    <portal-target name="vgp-date-range-picker" />

    <!-- if viewType === 'needPass'  <PasswordPage /> -->
    <!-- if viewType === 'gantt'  <GanttView /> -->
  </div>
</template>

<script>
import axios from 'axios';
import app from '$$app';
import './libs/tooltips';
import SharedBoardPage from './views/board/SharedBoardPage.vue';
import SharedGanttView from './views/sharedViews/SharedGanttView.vue';
import appFilter from './views/filter/main.vue';
import Filter from './views/filter/filter';
//
// import locale from './plugins/localeShared';
//
// import WBSWorker from './components/workers/WBSWorker';

export default {
  name: 'SharedApp',
  components: {
    // appFilterOld,
    appFilter,
    SharedGanttView,
    SharedBoardPage,
  },
  props: {
    viewType: {
      type: String,
      required: true,
      default: '',
    },
    cdn: {
      type: String,
      default: '',
    },

    token: {
      type: String,
      default: '',
    },

    isTemplate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoaded: false,
      projectId: null,
      multiviewId: null,
      data: {},
    };
  },
  watch: {
    viewType: {
      handler(viewType) {
        const api = axios.create({
          baseUrl: '',
        });

        let token;
        let userId;

        if (this.isTemplate === 'true') {
          token = this.token;
          userId = 1;
        } else {
          const pathParts = location.pathname.split('/');

          token = pathParts[pathParts.length - 2];
          userId = pathParts[pathParts.length - 1];
        }

        if (viewType === 'board') {
          api.get(`/shared/data/board/${token}/${userId}`)
            .then(async ({ data: { data, system } }) => {
              data.boardView = true;
              await this.$store.dispatch('setData', { data, system });

              Filter.initForSharedGanttApp(data);
              this.isLoaded = true;
              this.removePreload();
            });
        } else if (viewType === 'gantt') {
          api.get(`/shared/data/gantt/${token}/${userId}`)
            .then(async ({ data: { data, system } }) => {
              this.projectId = data.project.id;

              if (!_.isEmpty(data.multiview)) {
                this.multiviewId = data.multiview.id;
              }

              window.GT = {
                ...window.GT,
                currency: system.currency,
              };

              await this.$store.dispatch('setData', { data, system });
              Filter.initForSharedGanttApp(data);
              this.isLoaded = true;
              this.removePreload();
            });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.sharedApp = this;
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    removePreload() {
      if (document.getElementById('preLoaderWrap')) {
        setTimeout(() => {
          document.getElementById('preLoaderWrap').style.opacity = 0;
          document.getElementById('preLoaderWrap').pointerEvents = 'none';
          setTimeout(() => {
            document.getElementById('preLoaderWrap').remove();
          }, 600);
        }, 500);
      }
    },
    onKeyDown(e) {
      if (e.keyCode === 27) {
        app.trigger('closeWindowOnEscKeyPressed');
      }
    },
  },
};
</script>

<style scoped lang="less">
.shared-app {
  height: 100vh;
  width: 100vw;
}
</style>
